import React, {Component} from 'react';
import {SanitizeClassNames} from '../common';
import moment from 'moment';
import leftArrow from '../images/arrow-left.png';
import rightArrow from '../images/arrow-right.png';

import './BigDateSelector.css';

export default class BigDateSelector extends Component{
    constructor(props){
        super(props);
        this.state = {
            date: this.props.date
        }

        this.next = this.next.bind(this);
        this.prev = this.prev.bind(this);
    }

    componentWillReceiveProps(nextProps){
        this.state.date = nextProps.date;
    }

    toString(){
        return moment(this.state.date).format(this.props.format || 'ddd, MMMM D, YYYY');
    }

    increment(){
        return this.props.increment || 7;
    }

    incrementDays(numDays){
        let date = moment(this.state.date);
        date.add(numDays, 'day');
        if(this.props.onChange){
            this.props.onChange(date);
        }
        this.setState({date:date});
    }

    next(){
        this.incrementDays(this.increment());
    }

    prev(){
        this.incrementDays(-this.increment());
    }

    render(){
        //console.log("BigDateSelector Render:");
        return(
            <div className={SanitizeClassNames(this, 'big-date-selector table inline align-middle')}>
                <div>
                    <div>{this.toString()}</div>
                    <div><img src={leftArrow} onClick={this.prev} className="arrow" /> <img src={rightArrow} onClick={this.next} className="arrow" /></div>
                </div>
            </div>
        )
    }
}


// WEBPACK FOOTER //
// ./src/components/BigDateSelector.js